<div class="dropdown-crud-container">
  <div class="autocomplete-container">
    <pmv-autocomplete [disabled]="disabled" [(ngModel)]="value" [label]="label" [forceSelection]="false" [suggestions]="suggestions"
      (complete)="completeMethod($event)" [field]="field || 'descricao'" [dropdown]="true" (select)="selectMethod()" (ngModelChange)="modelChange($event)">
    </pmv-autocomplete>
  </div>
  <div class="button-container">
    <!-- Botão pra adicionar -->
    <button *ngIf="hideRemoveButton || showPlusIcon" [disabled]="disableButton || !showPlusIcon" type="button" class="button-operation btn btn-primary btn-add-dropdown-crud"
      (click)="addItem()">
      <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
    </button>
    <!-- Botão pra remover -->
    <button *ngIf="!hideRemoveButton && !showPlusIcon" [disabled]="disableButton || showPlusIcon" type="button" class="button-operation btn btn-danger btn-add-dropdown-crud"
      (click)="removeItem()">
      <span class="glyphicon glyphicon-minus" aria-hidden="true"></span>
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbc.html